import { render, staticRenderFns } from "./BankingPayment.vue?vue&type=template&id=3248edef"
import script from "./BankingPayment.vue?vue&type=script&lang=js"
export * from "./BankingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports